import styled from "styled-components";
import { colors } from "../../../../styles";

export const StyledMedialaceholder = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.neutral.lighter};
    border-radius: 10px;
`;
